import { cn } from "utils/index";

const WarnIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0.5C10.5898 0.5 13.5 3.4105 13.5 7C13.5 10.5895 10.5898 13.5 7 13.5C3.41016 13.5 0.5 10.5901 0.5 7C0.5 3.40986 3.41016 0.5 7 0.5Z" stroke="#2F61B0" />
    <path
      d="M6.9997 2.71727C7.16076 2.7176 7.31812 2.76566 7.45188 2.85538C7.58564 2.94511 7.68981 3.07246 7.75122 3.22136C7.81263 3.37026 7.82853 3.53403 7.7969 3.69196C7.76528 3.84989 7.68755 3.9949 7.57354 4.10868C7.45954 4.22245 7.31436 4.29989 7.15637 4.33119C6.99837 4.36249 6.83464 4.34626 6.68587 4.28454C6.53709 4.22283 6.40995 4.11841 6.3205 3.98446C6.23105 3.85052 6.18331 3.69306 6.1833 3.532C6.1833 3.42486 6.20443 3.31878 6.24548 3.21983C6.28653 3.12087 6.34669 3.03098 6.42252 2.95531C6.49835 2.87963 6.58836 2.81965 6.6874 2.77881C6.78644 2.73796 6.89256 2.71705 6.9997 2.71727ZM6.1833 6.24587C6.18637 6.03139 6.27372 5.82673 6.42647 5.67614C6.57923 5.52555 6.78511 5.44113 6.99961 5.44113C7.21411 5.44113 7.42 5.52555 7.57275 5.67614C7.72551 5.82673 7.81286 6.03139 7.81592 6.24587L7.81592 10.0462C7.81286 10.2606 7.72551 10.4653 7.57275 10.6159C7.42 10.7665 7.21411 10.8509 6.99961 10.8509C6.78511 10.8509 6.57923 10.7665 6.42647 10.6159C6.27372 10.4653 6.18637 10.2606 6.1833 10.0462L6.1833 6.24587Z"
      fill="#2F61B0"
    />
  </svg>
);

const HeaderWithReminder = ({ children, className, ...rest }: React.ComponentProps<"div">) => {
  return (
    <div {...rest} className={cn("flex justify-between ", className)}>
      <span>{children}</span>
      <div className="flex items-center gap-x-[6px] font-normal">
        <WarnIcon />
        <div className="text-sm leading-[1.125rem] text-[#333]">
          <span>Please note: This window will automatically close after</span>
          <span className="font-medium text-[#2F61B0]">&nbsp;20 minutes</span>
          <span>&nbsp;of inactivity.</span>
        </div>
      </div>
    </div>
  );
};

export { HeaderWithReminder };
